<template>
  <div class="bookmark-item-sku">
    <div class="bookmark-item-sku__information-area">
      <ItemSkuBasicInformation
        :image-url="imageUrl"
        :brand-name="brandName"
        :item-name="itemName"
        :item-sku-name="itemSkuName"
        :item-id="itemId"
        :item-sku-id="itemSkuId"
        :out-of-stock="outOfStock"
        :link-url="linkUrl"
        :labels="labels"
        class="bookmark-item-sku__sku-basic-information"
        @click-sku-basic-information="clickSkuBasicInformation"
      />
      <div class="bookmark-item-sku__delete-button-area">
        <button
          class="bookmark-item-sku__delete-button"
          @click="clickDeleteButton"
        >
          削除
        </button>
      </div>
    </div>
    <div v-if="!outOfStock" class="bookmark-item-sku__button-area">
      <ButtonSecondary
        text="自分用に購入する"
        @click-secondary-button="clickPersonalUseButton"
      />
      <ButtonPrimary
        text="ギフトを贈る"
        @click-primary-button="clickSendButton"
      />
    </div>
  </div>
</template>
<script>
import ItemSkuBasicInformation from '../../atoms/item-sku-bookmark/ItemSkuBasicInformation.vue'
import ButtonPrimary from '../../molecules/buttons/ButtonPrimary.vue'
import ButtonSecondary from '../../molecules/buttons/ButtonSecondary.vue'
export default {
  components: {
    ItemSkuBasicInformation,
    ButtonPrimary,
    ButtonSecondary
  },
  props: {
    userItemSkuBookmarkId: {
      type: Number,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: false,
      default: ''
    },
    brandName: {
      type: String,
      required: true
    },
    itemId: {
      type: Number,
      required: true
    },
    itemSkuId: {
      type: Number,
      required: true
    },
    outOfStock: {
      type: Boolean,
      required: false,
      default: false
    },
    linkUrl: {
      type: String,
      required: false,
      default: ''
    },
    labels: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  methods: {
    clickSkuBasicInformation() {
      this.$emit(
        'click-sku-basic-information-in-bookmark-item-sku',
        this.itemSkuId
      )
    },
    clickDeleteButton() {
      this.$emit(
        'click-bookmark-item-delete',
        this.userItemSkuBookmarkId,
        this.itemSkuId
      )
    },
    clickPersonalUseButton() {
      this.$emit(
        'click-personal-use-button-in-bookmark-item-sku',
        this.itemId,
        this.itemSkuId
      )
    },
    clickSendButton() {
      this.$emit(
        'click-send-button-in-bookmark-item-sku',
        this.itemId,
        this.itemSkuId
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.bookmark-item-sku {
  display: flex;
  flex-direction: column;
  max-width: $small-contents-width;
  padding: 16px;
  align-items: center;
  gap: 16px;
  margin: auto;

  &:not(:first-child) {
    border-top: 1px solid $gray-2;
  }

  &__information-area {
    display: flex;
    gap: 16px;
    align-items: center;
    width: 100%;
  }

  &__sku-basic-information {
    width: 100%;
    overflow-x: hidden;
    cursor: pointer;
  }

  &__delete-button {
    @extend %minimal;
    color: $black;
    border-radius: 4px;
    background: $gray-2;
    width: 38px;
    height: 26px;
    cursor: pointer;
  }

  &__button-area {
    display: flex;
    gap: 16px;
    width: 100%;

    button {
      height: auto;
      font-size: 1.2rem;
      line-height: 1.6;
      font-weight: bold;
      padding: 8px 0;
    }
  }
}
</style>
